import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { array, TArrayCodec } from "../../../shared/src/codecs/types/array";
import { boolean, TAnyBooleanCodec } from "../../../shared/src/codecs/types/boolean";
import { string, TAnyStringCodec } from "../../../shared/src/codecs/types/string";
import { formIO, TFormIOCodec } from "../../../shared/src/codecs/types/formIO";
import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { Job1, TJob1Codec } from "../Job";
import { PlainUser, StaffUser, TPlainUserCodec, TStaffUserCodec } from "../User";

export const JobsFormIO: TFormIOCodec<
    TRequiredCodec<{
        user_id: TAnyStringCodec,
        is_anyone: TAnyBooleanCodec,
    }>,
    TRequiredCodec<{
        filterable_case_users: TArrayCodec<TStaffUserCodec>,
        jobs: TArrayCodec<TJob1Codec>,
        all_staff_users: TArrayCodec<TStaffUserCodec>,
        adhoc_assignable_users: TArrayCodec<TPlainUserCodec>,
    }>
> = formIO(
    required({
        user_id: string(),
        is_anyone: boolean(),
    }),
    required({
        filterable_case_users: array(StaffUser),
        jobs: array(Job1),
        all_staff_users: array(StaffUser),
        adhoc_assignable_users: array(PlainUser),
    })
);

export type TJobsFormIOCodec = typeof JobsFormIO;

export type TJobsFormIO = TTypeOfCodec<TJobsFormIOCodec>;
